import { Button } from "$components/button/button";
import { styled } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const Banner = styled("aside")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
  backgroundColor: theme.palette.warning.main,
  color: theme.palette.warning.contrastText,
  padding: theme.spacing(1.5, 2),
  margin: theme.spacing(0, 0, 2, 0),
  borderRadius: theme.spacing(0.5),
}));

type Props = {
  count: number;
  /**
   * Enters review mode (sets `?review=true`). Omitted while already reviewing —
   * acknowledging then happens from the bottom action bar, so the banner stays
   * purely informational.
   */
  onReview?: () => void;
};

export const PriceReviewBanner: FC<Props> = ({ count, onReview }) => {
  return (
    <Banner data-testid="priceList.reviewBanner">
      <span>
        <FormattedMessage
          id="priceList.reviewBanner.message"
          defaultMessage="{count, plural, one {# price} other {# prices}} updated since you last reviewed"
          values={{ count }}
        />
      </span>
      {onReview && (
        <Button
          color="primary"
          variant="contained"
          size="small"
          onClick={onReview}
          data-testid="priceList.reviewBanner.review"
        >
          <FormattedMessage
            id="priceList.reviewBanner.review"
            defaultMessage="Review prices"
          />
        </Button>
      )}
    </Banner>
  );
};
